import React from 'react';
import { Box as MuiBox, BoxProps as MuiBoxProps } from '@material-ui/core';
export interface BoxProps extends MuiBoxProps {
  children?: React.ReactNode;
}

export function Box({ children, ...props }: BoxProps) {
  return <MuiBox {...props}>{children}</MuiBox>;
}
